/**
 * Main entry point for the bundled script
 */
import ui from "./src/ui";

// Include scss file to ensure it is included in the build
require('../style/main.scss');

// Initialize the UI (includes porto theme initialization)
ui.initialize();


// WEBPACK FOOTER //
// ./build/script/main.js